import './Shared/app.js';
import './Shared/Modules/AwesomeScrollbar.js';
import './Shared/Modules/AwesomeHorizontalScrollbar.js';
import './Shared/Modules/About.js';
import './Shared/Modules/ContentSlider.ts';
import './Shared/Modules/CurrentDatetime.js';
import './Shared/Modules/CustomSelect.js';
import './Shared/Modules/Help.js';
import './Shared/Modules/PageContent.js';
import './Shared/Modules/PageNavigation.js';
import './Shared/Modules/MainNavigation.js';
import './Shared/Modules/LiveTimer.js';
import './Shared/Modules/ModalWindow.js';
import './Shared/Modules/ModalMarkets.js';
import './Shared/Modules/Broadcast.ts';
import './Shared/Modules/VerticalMenu.js';
import './Shared/Modules/Balance.js';
import './Shared/Modules/LayoutRightColumn.js';
import './Shared/Modules/LayoutResolver.js';
import './Shared/Modules/Favorites.js';
import './Shared/Modules/Search.js';
import './Shared/Modules/StatisticsSingle.js';
import './Shared/Modules/Tooltip.js';
import './Shared/Modules/TooltipEventInfo.js';
import './Shared/Modules/TooltipEventScore.js';
import './Shared/Modules/Combobox.js';
import './Shared/Modules/ConfirmButton.js';
import './Shared/Modules/SuperexpressPagination.js';
import './Shared/Modules/UpButton.js';
import './Shared/Modules/MobileAppDownloadButton.js';
import './Shared/Modules/AccountMessage.js';
import './Shared/Modules/TimeZone.js';

//HomeWidgets
import './Shared/Modules/HomeWidgets/HomeWidgets.js';
import './Shared/Modules/HomeWidgets/WidgetBanners.js';
import './Shared/Modules/HomeWidgets/WidgetHelp.js';
import './Shared/Modules/HomeWidgets/WidgetPromo.js';

//Split by spa-areas
//---empty

import './Shared/Modules/BettingCart/Freebet.js';
import './Shared/Modules/BettingCart/StandardCart.js';
import './Shared/Modules/BettingCart/StandardCartItem.js';
import './Shared/Modules/BettingCart/StandardCartCalc.js';
import './Shared/Modules/BettingCart/OneclickCart.js';
import './Shared/Modules/BettingCart/BettingCart.js';

import './Shared/Modules/BookmakerPromocode.js';

import './Shared/Modules/Superexpress.js';

//old inceptions (to order)
import './Shared/Modules/Shared/ErrorHandler.js';
